import { Col, Collapse, Container, Row } from "react-bootstrap";
import classes from "../ServicesTable.module.scss"
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import TaskIcon from '@mui/icons-material/Task';
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Controller, useWatch } from "react-hook-form";

const apiRequestAddress = process.env.REACT_APP_FILE_ENDPOINT || window.location.origin + "/File";

const CertificateInput = ({register, setValue, control, name, disabled}) => {
    const [hasFile, setHasFile] =  useState(false);
    const [mouseOver, setMouseOver] = useState(false);
    //const [downloadValue, setDownloadValue] = useState();
    const [isDragging, setIsDragging] = useState(false); // local
    const inputRef = useRef();
    const downloadref = useRef();
    const value = useWatch({control, name});

    useEffect(() => {
        //console.log(value);
        if(value && value.indexOf("File") > -1){
            setHasFile(true);
        }else{
            setHasFile(false);
        }
    }, [value])

    const onClick = (e) =>{
        if(disabled) return;

        if(hasFile){
            downloadref.current.click();
        }else{
            inputRef.current.click();
        }
    }
    const onRemoveClick = (e) => {
        if(disabled) return;
        e.preventDefault();
        e.stopPropagation();
        setValue(name, null);
    }
    const onFileUploadHandler = (e) =>{
        if(!e?.target?.files || e.target.files.length < 1)
            return;
        const fileData = new FormData();
        fileData.append("file", e.target.files[0]);
        axios.post(apiRequestAddress, fileData, {
            headers: {
            "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
        })
        .then((res) => {
            inputRef.current.value=null;
            if (res?.data?.Result && res?.data?.Status?.toUpperCase() === "OK") {
                let certPath = `File/${res?.data?.Result?.Id}`;
                setValue(name, certPath);
            }
        });
    }
    


    const uploadFile = (file) => {
        if (!file) return;

        const fileData = new FormData();
        fileData.append("file", file);

        axios
            .post(apiRequestAddress, fileData, {
            headers: { "Content-Type": "multipart/form-data" },
            withCredentials: true,
            })
            .then((res) => {
            if (res.data.Result && res.data.Status.toUpperCase() === "OK") {
                const certPath = `File/${res.data.Result.Id}`;
                setValue(name, certPath);
            }
            })
            .catch((err) => {
            console.error("File upload failed:", err);
            // Optionally show an error message to the user
        });
    };

    useEffect(() => {
        const preventDefault = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };

        window.addEventListener("dragover", preventDefault);
        window.addEventListener("drop", preventDefault);

        return () => {
            window.removeEventListener("dragover", preventDefault);
            window.removeEventListener("drop", preventDefault);
        };
    }, []);
    const dragCounter = useRef(0);

    const onDragEnter = (e) => {
        e.preventDefault();
        dragCounter.current += 1;
        setIsDragging(true);
    };

    const onDragLeave = (e) => {
        e.preventDefault();
        dragCounter.current -= 1;
        if (dragCounter.current <= 0) {
            setIsDragging(false);
            dragCounter.current = 0;
        }
    };

    const onDropHere = (e) => {
        e.preventDefault();
        dragCounter.current = 0;
        setIsDragging(false);

        const files = e.dataTransfer?.files;
        if (!files || files.length < 1) return;
        uploadFile(files[0]);
    };
    const onDragOver = (e) => {
        e.preventDefault(); // Required to allow drop
    };

    //const {}
    return (
        <Container className={`${classes["certificateWrapper"]} d-flex flex-column`} onClick={onClick} onMouseEnter={() => setMouseOver(true)} onMouseLeave={() => setMouseOver(false)}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDragOver={onDragOver}
            onDrop={onDropHere}
            style={{
                border: isDragging ? "2px dashed rgba(0,86,131,0.5)" : "1px solid black",
                borderRadius: "8px",
                padding: "0.5rem",
                transition: "border-color 0.2s ease-in-out, background-color 0.2s ease-in-out",
            }}>
            <Row style={{justifyContent:"center", alignItems:"center", height:"100%"}}>
                <Col style={{padding:"0px"}}>
                    {hasFile && <TaskIcon className={classes["cetificateIcon"]} style={{color:"#0c631f", width:"4rem", height:"4rem"}}/>}
                    {!hasFile && <FileUploadIcon className={classes["cetificateIcon"]} style={{color:"#3b3b3b", width:"4rem", height:"4rem"}}/>}
                </Col>
            </Row>
            {hasFile &&
            <Collapse in={mouseOver}>
            <div style={{position:"absolute", top:"0.1em", right:"0.2em"}}>
                <HighlightOffIcon style={{width:"0.9rem", height:"0.9rem", color:"rgba(0,86,131,1)", zIndex:"110"}} onClick={onRemoveClick}/>
            </div>
            </Collapse>
            }
            {!hasFile && 
            <Collapse in={mouseOver}>
            <div style={{position: "absolute", bottom:"0px", left:"0", width:"100%", height:"2rem", borderRadius:"0px 0px 5px 5px", backgroundColor:"rgba(0,86,131,1)", color:"white"}}>
                Upload
            </div>
            </Collapse>}
            {isDragging && !disabled && (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0, 86, 131, 0.6)",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "1.2rem",
                        fontWeight: 500,
                        borderRadius: "8px",
                        zIndex: 120,
                    }}
                >
                    Drop
                </div>
            )}
            <input type="file" style={{display:"none"}} ref={inputRef} onChange={onFileUploadHandler}></input>
            <input type="text" style={{display:"none"}}  {...register(name)}></input>
            <a href={"/"+value} style={{display:"none"}} ref={downloadref} download></a>
        </Container>
    )
}
export default CertificateInput;